export const awaitForValueWithTimeout = <T, O>(
    ms: number,
    func: (s: T) => O
): ((s: T) => Promise<O>) => {
    return (s: T) =>
        new Promise((resolve, reject) => {
            let timeout: number | undefined = undefined;
            let interval: number | undefined = undefined;
            let result: O | null = func(s);

            timeout = setTimeout(() => {
                clearInterval(interval);
                reject(result);
            }, ms);

            const handleResult = (result: O | null): boolean => {
                if (result) {
                    clearTimeout(timeout);
                    clearInterval(interval);
                    resolve(result);
                    return true;
                }
                return false;
            };

            if (handleResult(result)) {
                return;
            }

            interval = setInterval(() => {
                result = func(s);
                handleResult(result);
            }, 200);
        });
};
